import { render, staticRenderFns } from "./AddDiagnosis.vue?vue&type=template&id=6bedc8f8&scoped=true"
import script from "./AddDiagnosis.vue?vue&type=script&lang=js"
export * from "./AddDiagnosis.vue?vue&type=script&lang=js"
import style0 from "./AddDiagnosis.vue?vue&type=style&index=0&id=6bedc8f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bedc8f8",
  null
  
)

export default component.exports